import { tellTales } from "./TellTales";

export const REASON_NA = "N/A";

export const DEFAULT_DIAGNOSTICS_DIAGNOSTICMONITOR = [
  "DiagnosticElectricVehicleBatteryPowerId",
  "DiagnosticIgnitionId",
  "DiagnosticElectricVehicleChargingStateId",
  "DiagnosticOdometerId",
  "a8Q59homXrESC9eF_I_JTWA", // Parking brake telltale
  "agOXwO-vH0EW66Ry_cjkJrg", // Calibration
];

export const COCKPIT_DIAGNOSTICS = [
  "DiagnosticOutsideTemperatureId",
  "DiagnosticFuelLevelId",
  "DiagnosticEngineSpeedId",
  "DiagnosticDieselExhaustFluidId",
  "DiagnosticEngineCoolantTemperatureId",
  "DiagnosticStateOfChargeId",
  "DiagnosticCabInteriorTemperatureId",
  "DiagnosticDoor1StatusId",
  "DiagnosticDoor2StatusId",
  "aMkXsw2rqV0-pxn4ko_qlnA", // Door 3
  "DiagnosticElectricVehicleBatteryPowerId",
];

/**
 * What the live map asks every visible vehicle for, beyond its position.
 *
 * Named one by one rather than read out of the list by position: the map reads each of these back
 * by name, and an id inserted in the middle of a positional list would silently have it draw the
 * tank as the battery.
 *
 * Kept short on purpose. This is polled every two seconds for every vehicle on screen, so each id
 * here is paid for on every tick of a whole fleet.
 */
export const DIAGNOSTIC_STATE_OF_CHARGE_ID = "DiagnosticStateOfChargeId";
export const DIAGNOSTIC_FUEL_LEVEL_ID = "DiagnosticFuelLevelId";
export const DIAGNOSTIC_CHARGING_STATE_ID = "DiagnosticElectricVehicleChargingStateId";
/** AdBlue. */
export const DIAGNOSTIC_DEF_LEVEL_ID = "DiagnosticDieselExhaustFluidId";

export const MAP_DIAGNOSTICS = [
  DIAGNOSTIC_STATE_OF_CHARGE_ID,
  DIAGNOSTIC_FUEL_LEVEL_ID,
  DIAGNOSTIC_CHARGING_STATE_ID,
  DIAGNOSTIC_DEF_LEVEL_ID,
];

/**
 * The Geotab group the hydrogen vehicles are in.
 *
 * There is no field on a device saying how it is powered, so fuel-cell vehicles are recognised by
 * where they sit in the group tree. Shared because the H2 monitor page and the live map both have
 * to mean the same group by it.
 */
export const FUEL_CELL_GROUP_NAME = "07 Fuel Cell";

/**
 * The group that grants permission to set how the map looks for everyone.
 *
 * Group colours and group symbols are shared, so changing them changes the map for the whole
 * company; being in this group is what allows it. Users signing in with a `@fairfleet.de` address
 * are exempt, as they are from the other group-based restrictions.
 */
export const MAP_ADMIN_GROUP_NAME = "Map_Admin";

export const TELLTALES_DIAGNOSTICS = tellTales
  .filter(t => !t?.name?.includes("Reserved for"))
  .map(d => d.id);
